export default [
  {
    name: "Red Sunset",
    background: "linear-gradient(to bottom, #355c7d, #6c5b7b, #c06c84)",
    colorOnDark: "#ffffff",
    color1: "#6c5b7b",
    color2: "#c06c84",
  },
  {
    name: "Wedding Day Blues",
    background: "linear-gradient(to bottom, #33d190, #ff8c00, #ff0048)",
    colorOnDark: "#ffffff",
    color1: "#ff8c00",
    color2: "#ff8c00",
  },
  {
    name: "Nighthawk",
    background: "linear-gradient(to bottom,  #2980b9, #1d5980, #2c3e50)",
    colorOnDark: "#ffffff",
    color1: "#1d5980",
    color2: "#2980b9",
  },
];
